import * as SliderPrimitive from '@radix-ui/react-slider'
import * as styles from './slider.css'

type SliderProps = {
  defaultValue?: [number, number]
  min?: number
  max?: number
  step?: number
  value?: [number, number]
  onValueChange?: (value: [number, number]) => void
  'aria-label'?: string
  label?: string
}

const formatNumber = (num: number) => {
  return Number.isInteger(num) ? num.toString() : num.toFixed(1)
}

const renderStepLabels = (min: number, max: number, step: number, currentValue: [number, number]) => {
  const steps: number[] = []

  for (let i = min; i <= max; i += step) {
    steps.push(i)
  }

  return (
    <div className={styles.stepsContainer}>
      {steps.map((value, index) => (
        <span
          key={value}
          className={`${styles.stepLabel} ${value >= currentValue[0] && value <= currentValue[1] ? styles.stepLabelSelected : styles.stepLabelUnSelected}`}
          style={
            {
              '--left': `${(index * 100) / (steps.length - 1)}%`,
            } as React.CSSProperties
          }
        >
          {formatNumber(value)}
        </span>
      ))}
    </div>
  )
}

export const Slider = ({
  defaultValue = [25, 75],
  min = 0,
  max = 100,
  value,
  onValueChange,
  'aria-label': ariaLabel,
  label,
}: Omit<SliderProps, 'step'>) => {
  const step = (max - min) / 10

  return (
    <div className={styles.container}>
      {label && <label className={styles.label}>{label}</label>}
      <SliderPrimitive.Root
        className={styles.sliderRoot}
        defaultValue={defaultValue}
        min={min}
        max={max}
        step={step}
        value={value}
        onValueChange={onValueChange}
        aria-label={ariaLabel}
      >
        <SliderPrimitive.Track className={styles.sliderTrack}>
          <SliderPrimitive.Range className={styles.sliderRange} />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className={styles.sliderThumb} />
        <SliderPrimitive.Thumb className={styles.sliderThumb} />
      </SliderPrimitive.Root>
      {renderStepLabels(min, max, step, value || defaultValue)}
    </div>
  )
}
